import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import {
  GET_TOTAL_PROMOTIONS,
  type IGetTotalPromotions,
  type IGetTotalPromotionsVariables,
} from '@commerce/core'
import { storiesFromPromotions } from '../home/promotions'
import type { Story } from '../demo'

export interface UsePromotions {
  /** The active promotions as reels, priority-ordered. Empty means no reels. */
  stories: Story[]
  loading: boolean
}

/**
 * The home's reels, from the storefront-wide promotions.
 *
 * A failed or empty fetch both resolve to no reels, on purpose: the reel rail
 * is an accent, not load-bearing, so a promotions outage should cost the rail
 * quietly rather than block the catalog behind an error the shopper cannot act
 * on.
 */
export const usePromotions = (): UsePromotions => {
  const { slug = '', sessionId = '' } = useParams()

  const { data, loading } = useQuery<IGetTotalPromotions, IGetTotalPromotionsVariables>(
    GET_TOTAL_PROMOTIONS,
    { variables: { storefrontName: slug, sessionUid: sessionId } },
  )

  const stories = useMemo(
    () => storiesFromPromotions(data?.getTotalPromotions ?? []),
    [data],
  )

  return { stories, loading }
}
